










import {Component, Vue} from 'vue-property-decorator';
import {FeathersVuexFindAll} from '@/utils';
import ServicesPage from '@/components/Pages/Home Page/Services/ServicesPage.vue';
import HeroImage from '@/components/Views/Home Page/HeroImage.vue';

@Component({
    components: {
        HeroImage,
        ServicesPage,
    },
})
export default class ServicesMakeup extends Vue {
    private header = 'Makeup';
    private hero1 = 'BEAUTY MAY BE PAIN...BUT SOPLUSH IS HAPPINESS';
    private heroImage = '../img/serviceTypes/Makeup.jpeg';
    private title = 'Makeup';
    private crumbs = [
        {name: 'Home', path: '/'},
        {name: 'Services', path: '/services'},
        {name: 'Makeup', path: '/services/makeup-services'},
    ];
    public serviceQuery = null;
    public mounted() {
        this.setServiceQuery();
    }
    public async setServiceQuery() {
        const {ServiceType, Category} = this.$FeathersVuex;
        const serviceTypes = await FeathersVuexFindAll(ServiceType, {
            query: {
                name: 'Makeup',
            },
        });
        const [category] = await FeathersVuexFindAll(Category, {
            query: {
                name: 'Personal',
            },
        });
        this.serviceQuery = {
            serviceTypes: {$in: serviceTypes.map((x) => x._id)},
            category: category._id,
            $sort: {
                displayOrder: 1,
            },
        };
    }
    private body = [
        'Genuine Makeup Services without Any Compromises',
        'Makeup Services',
        'One of the things that has the biggest influence on whether many people feel put together or thoroughly out-of-sorts is makeup. When it is done well, it is probably the thing that contributes the most to your feeling that you look both professional and beautiful. However, who would want to go out just to get makeup done? Sometimes it seems like it would be easier to just do your makeup yourself. Even if it doesn\'t look quite as good, at least you won\'t have to go to all the same trouble.',
        'Doing makeup is an art that shouldn\'t be taken lightly. It makes all the difference in how other people see you and how you present yourself. It may also contribute greatly to your happiness to know that you are looking the best you possibly can. For that reason, we have made it so that you can have a makeup artist come to your door, your studio or your event and give you a gorgeous makeover.',
        'One of the best things that we can do for your wedding or other big event is airbrush makeup. This is also especially good for rewards ceremonies or other big events, and it is virtually a must-have if you are going to be on camera.',
        'We can do airbrush makeup with lashes for natural beauty that highly accentuates the shape and color of your eyes to make them more noticeable than ever. You can also go with the normal forms of application, which are still extraordinarily beautiful and will bring unending admiration from your friends.',
        'For less formal events or a typical night on the town, a regular application of makeup is often the best choice. Makeup with lashes is an option that accentuates your natural attractiveness. One type of makeup is contour makeup. This is essential to a true makeover, as it gives the impression of changing the very shape and features of your face. Careful shading with matte cream or powder will create an entirely new look to alter your appearance in such a way that you come across as all the more glamorous.',
        'For photos or business meetings and events, nothing is better than a professional look, but we can also create an alluring, magical look that will fit your parties and other evening events perfectly. SoPlush Beauty Pros comes to you to give you the best experience possible. You never have to put up with the annoyance of finding time in your busy day to go to the hairdresser again.',
    ];
}
